import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserContext } from "../../UserContext";
import "./Login2.css"; // On va mettre l'animation ici
import API_URL from "../config";

const Login2 = () => {
  const { setUser } = useContext(UserContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const response = await axios.post(
        `${API_URL}/login/`,
        { username, password },
        { headers: { "Content-Type": "application/json" } },
      );

      const userInfo = {
        username: response.data.username,
        email: response.data.email,
        codetab: response.data.codetab,
        libetab: response.data.libetab,
        permission_ids: response.data.permission_ids,
      };
      setLoading(false);
      localStorage.setItem("access_token", response.data.access_token);
      localStorage.setItem("refresh_token", response.data.refresh_token);
      localStorage.setItem("user_info", JSON.stringify(userInfo));

      setUser(userInfo);
      navigate("/menp");
    } catch (err) {
      if (err.response)
        setError(err.response.data.error || "Identifiants invalides");
      else setError("Erreur serveur");
    } finally {
      setLoading(false); // 🔥 TOUJOURS exécuté
    }
  };

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 login-bg">
      {/* TITRE MULTICOLORE ANIMÉ */}
      <h1 className="animated-gradient-title">NADINE'S HAIR BRAIDING SYSTEM</h1>

      {/* LOGIN CARD */}
      <div
        className="card shadow-lg p-4"
        style={{ maxWidth: "400px", width: "100%", borderRadius: "12px" }}
      >
        <div className="text-center mb-3">
          <img
            src={require("../../assets/images/logo_fenasu.png")}
            alt="logo"
            style={{ width: "120px" }}
          />
        </div>

        {error && (
          <div className="alert alert-danger text-center py-1" role="alert">
            {error}
          </div>
        )}

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="form-control-lg"
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="form-control-lg"
            />
          </Form.Group>

          <button
            type="submit"
            className="btn btn-primary btn-lg w-100 fw-bold"
            style={{ borderRadius: "8px" }}
          >
            Login..
          </button>
        </Form>
      </div>
    </div>
  );
};

export default Login2;
